<template>
  <div v-if="!instagramPosts" id="instagram-loader">
    <font-awesome-icon :icon="['fab', 'instagram']" class="icon fa-spin"></font-awesome-icon>
  </div>
  <div v-else id="instagram-container">
    <div v-if="instagramPosts" class="instagram-feed">
      <a href="https://www.instagram.com/npcgym/" class="col header">
        <font-awesome-icon :icon="['fab', 'instagram']" class="icon"></font-awesome-icon>
        <p>Instagram flöde</p>
      </a>
      <a
        :href="post.link"
        class="image col"
        v-for="post in instagramPosts.slice(0, 5)"
        :key="post.id"
      >
        <video
          v-if="post.videos"
          :src="post.videos.low_resolution.url"
          muted
          autoplay
          loop
          playsinline
        ></video>
        <img v-else :src="post.images.standard_resolution.url" />
        <div class="info">
          <font-awesome-icon :icon="['far', 'heart']"></font-awesome-icon>
          <p>{{post.likes.count}}</p>
          <font-awesome-icon :icon="['far', 'comment']" class="comment-icon"></font-awesome-icon>
          <p>{{post.comments.count}}</p>
        </div>
      </a>
    </div>
    <div v-if="instagramPosts && !isMobile" class="instagram-feed">
      <a
        :href="post.link"
        class="image col"
        v-for="post in instagramPosts.slice(5,11)"
        :key="post.id"
      >
        <video
          v-if="post.videos"
          :src="post.videos.low_resolution.url"
          muted
          autoplay
          loop
          playsinline
        ></video>
        <img v-else :src="post.images.standard_resolution.url" />
        <div class="info">
          <font-awesome-icon :icon="['far', 'heart']"></font-awesome-icon>
          <p>{{post.likes.count}}</p>
          <font-awesome-icon :icon="['far', 'comment']" class="comment-icon"></font-awesome-icon>
          <p>{{post.comments.count}}</p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import userHandler from '@/services/userHandler'
import { mapGetters } from 'vuex'
import logFile from '@/script/log'
const log = logFile('instagram-feed')

export default {
  data () {
    return {
      instagramPosts: null
    }
  },
  computed: mapGetters(['isMobile']),
  mounted () {
    // this.getInstagramPosts()
  },
  methods: {
    getInstagramPosts () {
      userHandler
        .getInstagramPosts(this.isMobile)
        .then((instagramPosts) => {
          this.instagramPosts = instagramPosts.data.slice(
            0,
            this.isMobile ? 5 : 14
          )
        })
        .catch((err) => log.error(err))
    }
  }
}
</script>

<style scoped lang="less">
@import '../styles/variables';

#instagram-container {
  background-color: @color-grey-light;
  transition: 0.3s ease-out;
  width: calc(100% - 20px);
  margin: 0 10px;
}
#instagram-loader {
  background-color: @color-grey-light;
  padding: 20px 0;
  width: 100%;
}
.icon {
  color: @color-grey-dark;
  width: auto;
  font-size: 80px;
}
.instagram-feed {
  color: white;
  display: flex;
  justify-content: space-around;
}
.instagram-feed:not(:first-child) {
  margin-top: 10px;
}
.col {
  border-radius: @radius-small;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.08);
  border: 2px solid white;
  flex: 1;
  height: auto;
  justify-content: center;
}
.col:not(:last-child) {
  margin-right: 10px;
}
.header {
  background: white;
  padding-top: @margin-small;
}
@media screen and (max-width: @xs-max-width) {
  .instagram-feed {
    flex-direction: column;
  }
  .col {
    width: 100%;
    max-height: 200px;
    height: auto;
    margin-bottom: 5px;
  }
}

.image {
  background: white;
  position: relative;
  color: white;
  overflow: hidden;
  img,
  video {
    height: 100%;
    width: 100%;
    background-size: cover;
    object-fit: cover;
  }
  .info {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 5px 8px;
    p {
      margin: 0;
      margin-left: 3px;
    }
    .comment-icon {
      margin-left: 10px;
    }
  }
}
.col:hover {
  border-bottom-color: @color-secondary;
}
</style>
